module.exports = __webpack_public_path__ + "static/assets/8fa3a21413d29b9a61ed992b45ee7e9f.svg";